module.exports = __webpack_public_path__ + "img/coke-zero_2.f93617f8.jpg";